import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { StarRatingInput } from '@liveauctioneers/hammer-ui-core/starRatingInput';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { useState } from 'react';

import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';

type Props = {
    className?: string;
    onChange: (value: number) => void;
};

export const RatingInput = ({ className, onChange }: Props) => {
    const isMobile = useIsMobileLayout();
    const [activeValue, setActiveValue] = useState(0);

    return (
        <div className={cn('mt-xs flex', isMobile ? 'flex-col' : 'flex-row', className)}>
            <StarRatingInput
                filledClassName="text-interactive-primary"
                onActiveValueChange={setActiveValue}
                onChange={onChange}
                size="lg"
                testid="star-picker"
                unfilledClassName="text-border-secondary"
            />
            <div className={cn(isMobile ? 'mt-xs' : 'mx-2xs my-auto')}>
                {activeValue > 0 && (
                    <BodyPrimary color="secondary">
                        <FormattedMessage id={`review_page.review_copy._${activeValue}`} />
                    </BodyPrimary>
                )}
            </div>
        </div>
    );
};
